import React from 'react';

import {
  PERSONALIZATION_DEFAULT_HELP,
  personalizationFilterClauses,
} from './filterSummaryClauses';

import styles from './personalization.module.scss';

export const PersonalizationSetFilterSummary = ({ activeSet, dynamic = false }) => {
  const clauses = personalizationFilterClauses(activeSet?.filterRows);

  if (!clauses.length) {
    return (
      <p className={styles.helpText}>
        {PERSONALIZATION_DEFAULT_HELP}
        {dynamic &&
          ' Changing layout filters outside personalization removes assets that no longer match from each set.'}
      </p>
    );
  }

  return (
    <div className={styles.filterSummaryBlock}>
      <p className={styles.filterSummary}>
        <span>Show these assets whenever </span>
        {clauses.map((clause, index) => (
          <React.Fragment key={`${clause}-${index}`}>
            {index > 0 && (
              <span className={styles.filterSummarySeparator} aria-hidden>|</span>
            )}
            <span>{clause}</span>
          </React.Fragment>
        ))}
        <span> triggers</span>
      </p>
      <p className={styles.filterSummaryHint}>
        Add or modify filters to update which assets display automatically
      </p>
    </div>
  );
};

export default PersonalizationSetFilterSummary;
